import { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { PrimeIcons } from 'primereact/api'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'

import { HandleableError, getHandleableError } from './isXiaError'

export function FallbackErrorMessage(props: FallbackProps) {
  const { t } = useTranslation()
  const { error, resetErrorBoundary } = props

  const retryableStatus = [408, 429, 504]

  const content = (error: HandleableError, onRetry?: () => void) => (
    <div className="flex justify-content-between p-inline-message p-component p-inline-message-error gap-2 w-full">
      <div className="flex align-items-center justify-content-start">
        <i className={`${PrimeIcons.TIMES_CIRCLE} p-inline-message-icon`} />
        <div className="flex flex-column p-inline-message-text">
          <strong>{error.title || t('errors.generic.unknown.title')}</strong>
          <span>{error.message}</span>
        </div>
      </div>

      {retryableStatus.includes(error.status) && (
        <Button
          onClick={onRetry}
          label={t('common.labels.retry')}
          icon={PrimeIcons.REFRESH}
          severity="danger"
          size="small"
        />
      )}
    </div>
  )

  return (
    <>
      <Message
        className="my-4 w-full justify-content-start"
        severity="error"
        content={content(getHandleableError(error), resetErrorBoundary)}
      />
    </>
  )
}

export default FallbackErrorMessage
